/* tslint:disable */

import { ReaderInlineDataFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useSearchCorrections_itemSearch = {
    readonly searchCorrections: {
        readonly forceSearchUri: string | null;
        readonly originalSearchTerm: string | null;
        readonly semanticSearchTerm: string | null;
        readonly classificationLevel: string | null;
        readonly classificationSearchTerm: string | null;
    } | null;
    readonly " $refType": "useSearchCorrections_itemSearch";
};
export type useSearchCorrections_itemSearch$data = useSearchCorrections_itemSearch;
export type useSearchCorrections_itemSearch$key = {
    readonly " $data"?: useSearchCorrections_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"useSearchCorrections_itemSearch">;
};



const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useSearchCorrections_itemSearch"
};
(node as any).hash = '9174a8ae849e59a45d084c56e81f8042';
export default node;
